import Consultation from "./load";
import Debounce from "../../util/debounce";
// import animationend from "../../util/animationend";

Consultation.prototype.gotoNextIfPickOneQuestion = function (survey, options) {
    // if there is only one question on the page,
    // and it's a radiogroup, then automagically go to the
    // next page.
    if (!survey.goNextPageAutomatic) {
        var question = options.question;
        if (!question) return;
        var element = jQuery('#' + question.id);
        if (element.find('input[type=radio]').length > 0) {
            if (survey.currentPage.questions.length > 1) {
                // console.log('Too many questions on page to auto next');
            } else {
                // console.log('Jumping to next page');
                // we need a delay so that survey has time to readjust based on
                // answer, otherwise we progress as if we have not answered.
                setTimeout(function () {
                    survey.nextPage();
                }, 300);
            }
        } else {
            // console.log("question is not a radio");
        }
    } else {
        // console.log('goNextPageAutomatic is already set in the survey');
    }
}


Consultation.prototype.convertQuestionnaireOutputToVarDict = function (surveyOutput) {
    var varDict = {};
    jQuery.each(surveyOutput, function (_i, v) {
        if (jQuery.isArray(v)) {
            jQuery.each(v, function (_ii, vv) {
                if(!(typeof vv == 'string' && vv.startsWith('MaxCapsules'))) { // we don't want to pass MaxCapsulesN answers into the varDict
                    varDict[vv] = true;
                }
            });
        } else {
            if(!(typeof v == 'string' && v.startsWith('MaxCapsules'))) { // we don't want to pass MaxCapsulesN answers into the varDict
                varDict[v] = true;
            }
        }
    });
    // console.log(varDict);
    return varDict;
}

Consultation.prototype.hideDynamicAnswers = function (survey, options) {
    var that = this;
    var varDict = this.convertQuestionnaireOutputToVarDict(survey.data);
    // find all showIf choices in survey
    var questionsWithShowIf = this.findQuestionsWithShowIfChoices(survey);
    jQuery.each(questionsWithShowIf, function (i, question) {
        that.removeChoicesIfShowIfFalse(varDict, question);
    });
}

Consultation.prototype.findQuestionsWithShowIfChoices = function (survey) {
    // find all showIf choices in survey
    var questions = [];
    jQuery.each(survey.pages, function (i, page) {
        jQuery.each(page.questions, function (i, question) {
            var hasShowIfs = false;
            jQuery.each(question.choicesBackup ? question.choicesBackup : question.choices, function (i, choice) {
                if (choice.answerVars && choice.answerVars.showIf) {
                    hasShowIfs = true;
                }
            });
            if (hasShowIfs) {
                questions.push(question);
                // if this question hasn't backed up the choices yet, do it now.
                if (!question.choicesBackup) {
                    question.choicesBackup = question.choices.slice(); // copy it
                }
            }
        });
    });
    return questions;
}

Consultation.prototype.consoleLogCurrentState = function (survey, options) {
    return;
    console.log('consoleLogCurrentState');
    // console.log(survey.data);
    // different to vive.js's function. use this to log products/scores as we go
    var that = this;
    var results;
    if (!this.scores) {
        jQuery.getJSON(that.truth_table_json, function (truth_table_json) {
            that.truth_table = truth_table_json;
            jQuery.getJSON(that.scores_json, function (scores_json) {
                that.scores = scores_json;
                results = that.surveyCompleteProcessAnswers(survey);
                console.log('results.reports',results.reports);
            });
        });
    }
    else {
        results = that.surveyCompleteProcessAnswers(survey);
        console.log('results.reports',results.reports);
    }

}

Consultation.prototype.getQuestionTypeFromSurveyJson = function (question_id) {
    // sadly the survey itself doesn't make it clear what type of question a question is (weird),
    // so we have to look at our original json spec to find the type.
    var $qtype;
    jQuery.each(surveyJSON['pages'], function (i, page) {
        jQuery.each(page['elements'], function (ii, question) {
            if (question['name'] == question_id) $qtype = question['type'];
        });
    });
    return $qtype;
}

Consultation.prototype.removeChoicesIfShowIfFalse = function (varDict, question) {
    question.choices = [];
    jQuery.each(question.choicesBackup, function (i, choice) {
        if (choice.answerVars && choice.answerVars.showIf) {
            if (varDict[choice.answerVars.showIf]) {
                question.choices.push(choice);
            }
        } else {
            question.choices.push(choice);
        }
    });
}

Consultation.prototype.slideNext = function () {

    // console.log('slideNext');
    var that = this;

    var surveyContainer = document.getElementById('surveyContainer');
    var slideContainer = document.getElementById('slidePrevQuestionContainer');

    surveyContainer.classList.add('next');
    slideContainer.classList.add('next');

    document.querySelector('#slidePrevQuestionContainer.next .sv_qstn').addEventListener('animationend', function () {
        // console.log('next animationend');
        slideContainer.innerHTML = "";
        surveyContainer.classList.remove('next');
        slideContainer.classList.remove('next');
        // backup
        surveyContainer.classList.remove('prev');
        slideContainer.classList.remove('prev');

        that.focusOnTextInput();
    });
}

Consultation.prototype.slidePrev = function () {

    // console.log('slidePrev');
    var that = this;

    var surveyContainer = document.getElementById('surveyContainer');
    var slideContainer = document.getElementById('slideNextQuestionContainer');

    surveyContainer.classList.add('prev');
    slideContainer.classList.add('prev');

    document.querySelector('#slideNextQuestionContainer.prev .sv_qstn').addEventListener('animationend', function () {
        // console.log('prev animationend');
        slideContainer.innerHTML = "";
        surveyContainer.classList.remove('prev');
        slideContainer.classList.remove('prev');
        // backup
        surveyContainer.classList.remove('next');
        slideContainer.classList.remove('next');

        that.focusOnTextInput();
    });
}

Consultation.prototype.focusOnTextInput = function () {
    var textInput = jQuery('#surveyContainer input[type="text"], #surveyContainer input[type="email"]')[0];
    if (typeof textInput != 'undefined') {
        textInput.focus();
    }
}

Consultation.prototype.hideAlert = function () {
    jQuery('.alert').addClass('hidden');
}

Consultation.prototype.alertLoading = function () {
    jQuery('.alert').removeClass('hidden');
    jQuery('.alert').addClass('loading');
}

Consultation.prototype.alertDanger = function () {
    jQuery('.alert').removeClass('hidden');
    jQuery('.alert').removeClass('loading');
}

Consultation.prototype.changeLoadingText = function (text = "") {
    if (text) {
        this.loadingEl.querySelector('.consultation__loading-text').innerHTML = text;
    }
}

Consultation.prototype.showLoading = function () {
    this.loadingEl.classList.add('fadeIn');
    this.loadingEl.classList.add('show');
    this.loadingEl.classList.remove('fadeOut');
}

Consultation.prototype.hideLoading = function () {
    this.loadingEl.classList.remove('fadeIn');
    this.loadingEl.classList.remove('show');
    this.loadingEl.classList.add('fadeOut');
}

Consultation.prototype.getPageTitles = function (survey) {

    var pages = [];
    var questions = survey.getAllQuestions(true);

    for (var i = 0; i < questions.length; i++) {
        pages.push(questions[i].page.title);
    }

    return pages.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    })

}

Consultation.prototype.nextButtonVisibility = function (opacity_value) {

    var next = document.querySelector('.sv_next_btn');

    if (next) {
        next.style.opacity = opacity_value;
        if (opacity_value) {
            next.style.visibility = "visible";
        }
        else {
            next.style.visibility = "hidden";
        }
    }

}

Consultation.prototype.checkPageTitle = function (oldPage, newPage, survey) {

    if (!oldPage || !newPage) {
        return;
    }

    if (oldPage.title == newPage.title) {
        return;
    }

    var that = this;

    dataLayer.push({
        'event': 'consultation-event',
        'customEventCategory': 'consultation',
        'customEventAction': 'new-section',
        'customEventLabel': newPage.title,
        'customEventValue': null
    });

    setTimeout(function () {
        that.renderPageTitles(newPage.title, that.getPageTitles(survey));
    }, 500);

}

Consultation.prototype.renderPageTitles = function (currentPageTitle, pages) {

    var pages_html = [],
        pageIndex = 0,
        translateY = 0,
        html = "";

    for (var i = 0; i < pages.length; i++) {
        html = "";
        html += "<span class='";
        if (currentPageTitle == pages[i]) {
            html += " current ";
        }
        html += "'>";
        html += pages[i];
        html += "</span>";
        pages_html.push(html);
    }

    html = pages_html.join("");
    this.pagesElMover.innerHTML = html;

    pageIndex = pages.indexOf(currentPageTitle);
    if (pageIndex > 1) {
        translateY = -1 * (pageIndex - 1) * 28;
        if (pageIndex >= (pages.length - 3)) {
            translateY = -1 * (pages.length - 4) * 28;
        }
    }

    this.pagesElMover.style.transform = "translateY(" + translateY + "px) translateZ(0)";

}

Consultation.prototype.fieldsetScrollListeners = function (fieldset) {


    var fieldset = null;

    if (window.innerWidth <= 800) {
        fieldset = document.querySelector('#surveyContainer .sv_qstn');
    }
    else {
        fieldset = document.querySelector('#surveyContainer .sv_qstn fieldset');
    }

    if (fieldset) {

        var that = this;

        this.checkFieldsetScroll(fieldset);
        fieldset.addEventListener('scroll', function () {
            that.checkFieldsetScroll(fieldset);
        });

        var resizeFunction = Debounce(function () {
            that.checkFieldsetScroll(fieldset);
        }, 100);

        window.addEventListener('resize', resizeFunction, false);

    }
}

Consultation.prototype.checkFieldsetScroll = function (fieldset) {

    var consultation = document.querySelector('.consultation');

    if (fieldset.scrollHeight > (fieldset.clientHeight) + 1) {
        fieldset.classList.add('scrollable');
        consultation.classList.add('scrollable');
        if ((fieldset.offsetHeight + fieldset.scrollTop) < fieldset.scrollHeight) {
            fieldset.classList.add('scrollDown');
            consultation.classList.add('scrollDown');
        }
        else {
            fieldset.classList.remove('scrollDown');
            consultation.classList.remove('scrollDown');
        }
        if (fieldset.scrollTop != 0) {
            fieldset.classList.add('scrollUp');
            consultation.classList.add('scrollUp');
        }
        else {
            fieldset.classList.remove('scrollUp');
            consultation.classList.remove('scrollUp');
        }
    } else {
        fieldset.classList.remove('scrollable');
        fieldset.classList.remove('scrollUp')
        fieldset.classList.remove('scrollDown');
        consultation.classList.remove('scrollable');
        consultation.classList.remove('scrollUp')
        consultation.classList.remove('scrollDown');
    }
};

export default Consultation;


// WEBPACK FOOTER //
// ./js/components/consultation/navigation.js